// Gallery Component
export function initGallery() {
  const gallery = {
    // Gallery data
    images: [
      {
        title: "Videolar",
        desc: "Profesyonel izolasyon uygulaması ile uzun ömürlü koruma",
        src: "/1.mp4",
        type: "Video",
      },
      {
        title: "Videolar",
        desc: "Profesyonel izolasyon uygulaması ile uzun ömürlü koruma",
        src: "/2.mp4",
        type: "Video",
      },
      {
        title: "Videolar",
        desc: "Profesyonel izolasyon uygulaması ile uzun ömürlü koruma",
        src: "/3.mp4",
        type: "Video",
      },
      {
        title: "Mantolama Detayı",
        desc: "Profesyonel mantolama işlemi detay görüntüsü",
        src: "referanslar/8.webp",
        type: "image",
      },
      {
        title: "Yalıtım Uygulaması",
        desc: "Bina dış cephesi yalıtım çalışması",
        src: "referanslar/9.webp",
        type: "image",
      },
      {
        title: "İzolasyon Detayı",
        desc: "Su izolasyonu teknik detay uygulaması",
        src: "referanslar/10.webp",
        type: "image",
      },
      {
        title: "Cephe Boyama",
        desc: "Bina cephesi boyama işlemi",
        src: "referanslar/11.webp",
        type: "image",
      },
      {
        title: "Yalıtım Sistemi",
        desc: "Isı yalıtım sistemi uygulaması",
        src: "referanslar/12.webp",
        type: "image",
      },
      {
        title: "Özel Söve Uygulama",
        desc: "Dekoratif söve uygulaması çalışması",
        src: "referanslar/888.webp",
        type: "image",
      },
      {
        title: "İnşaat Projesi",
        desc: "Genel inşaat ve tadilat çalışması",
        src: "referanslar/13.webp",
        type: "image",
      },
      {
        title: "Cephe Yenileme",
        desc: "Bina cephesi yenileme ve boyama",
        src: "referanslar/14.webp",
        type: "image",
      },
      {
        title: "İzolasyon Malzemesi",
        desc: "Kaliteli izolasyon malzemesi uygulaması",
        src: "referanslar/15.webp",
        type: "image",
      },
      {
        title: "Yapı İncelemesi",
        desc: "Yapı analizi ve inceleme çalışması",
        src: "referanslar/16.webp",
        type: "image",
      },
      {
        title: "Sıva Uygulaması",
        desc: "Profesyonel sıva uygulama tekniği",
        src: "referanslar/17.webp",
        type: "image",
      },
      {
        title: "Boya Çalışması",
        desc: "İç ve dış cephe boya uygulaması",
        src: "referanslar/18.webp",
        type: "image",
      },
      {
        title: "Yalıtım Detayı",
        desc: "Yalıtım malzemesi detay uygulaması",
        src: "referanslar/19.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/20.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/21.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/22.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/23.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/24.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/25.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/26.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/27.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/28.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/29.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/30.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/31.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/32.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/33.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/34.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/35.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/36.webp",
        type: "image",
      },
      {
        title: "Cephe Çalışması",
        desc: "Bina cephesi iyileştirme projesi",
        src: "referanslar/37.webp",
        type: "image",
      },
    ],
    currentPage: 0,
    itemsPerPage: 6,
    currentModalIndex: 0,

    init: function () {
      console.log("Gallery init started");
      this.totalItems = this.images.length;
      this.container = document.getElementById("gallery-container");
      this.prevBtn = document.getElementById("prev-btn");
      this.nextBtn = document.getElementById("next-btn");
      this.paginationInfo = document.getElementById("pagination-info");

      console.log("Gallery elements:", {
        container: this.container,
        prevBtn: this.prevBtn,
        nextBtn: this.nextBtn,
        paginationInfo: this.paginationInfo,
        totalItems: this.totalItems,
      });

      if (document.getElementById("gallery-container")) {
        if (!this.container) {
          console.error("Gallery container not found!");
          return;
        }
      }

      this.setupEventListeners();
      this.setupTouchEvents();
      this.setupModal();
      this.renderPage();
      this.updatePagination();
    },

    setupEventListeners: function () {
      if (this.prevBtn) {
        this.prevBtn.addEventListener("click", () => this.previousPage());
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener("click", () => this.nextPage());
      }

      // Keyboard navigation
      document.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") this.previousPage();
        if (e.key === "ArrowRight") this.nextPage();
        if (e.key === "Escape") this.closeModal();
      });
    },

    setupTouchEvents: function () {
      let startX = 0;
      let endX = 0;

      this.container.addEventListener(
        "touchstart",
        (e) => {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );

      this.container.addEventListener(
        "touchend",
        (e) => {
          endX = e.changedTouches[0].clientX;
          this.handleSwipe(startX, endX);
        },
        { passive: true }
      );
    },

    handleSwipe: function (startX, endX) {
      const threshold = 50; // minimum distance for swipe
      const diff = startX - endX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // Swipe left - next page
          this.nextPage();
        } else {
          // Swipe right - previous page
          this.previousPage();
        }
      }
    },

    setupModal: function () {
      this.modal = document.getElementById("fullscreen-modal");
      this.modalContent = document.getElementById("modal-content");
      this.closeModalBtn = document.getElementById("close-modal");
      this.modalPrev = document.getElementById("modal-prev");
      this.modalNext = document.getElementById("modal-next");

      if (this.closeModalBtn) {
        this.closeModalBtn.addEventListener("click", () => this.closeModal());
      }

      if (this.modal) {
        this.modal.addEventListener("click", (e) => {
          if (e.target === this.modal) this.closeModal();
        });
      }

      if (this.modalPrev) {
        this.modalPrev.addEventListener("click", () =>
          this.previousModalItem()
        );
      }

      if (this.modalNext) {
        this.modalNext.addEventListener("click", () => this.nextModalItem());
      }

      // Add mobile swipe support in modal
      if (this.modalContent) {
        let modalStartX = 0,
          modalEndX = 0;
        this.modalContent.addEventListener(
          "touchstart",
          (e) => {
            modalStartX = e.touches[0].clientX;
          },
          { passive: true }
        );
        this.modalContent.addEventListener(
          "touchend",
          (e) => {
            modalEndX = e.changedTouches[0].clientX;
            const delta = modalStartX - modalEndX;
            const threshold = 50;
            if (Math.abs(delta) > threshold) {
              if (delta > 0) {
                this.nextModalItem();
              } else {
                this.previousModalItem();
              }
            }
          },
          { passive: true }
        );
      }
    },

    renderPage: function () {
      console.log("Rendering page:", this.currentPage);
      if (!this.container) {
        console.error("Container not found in renderPage");
        return;
      }

      const startIndex = this.currentPage * this.itemsPerPage;
      const endIndex = Math.min(
        startIndex + this.itemsPerPage,
        this.totalItems
      );
      const currentItems = this.images.slice(startIndex, endIndex);

      console.log(
        "Current items to render:",
        currentItems.length,
        currentItems
      );

      this.container.innerHTML = "";

      currentItems.forEach((item, index) => {
        const globalIndex = startIndex + index;
        const galleryItem = this.createGalleryItem(item, globalIndex);
        this.container.appendChild(galleryItem);
      });

      console.log("Gallery items rendered:", this.container.children.length);
    },

    createGalleryItem: function (item, index) {
      const div = document.createElement("div");
      div.className = "gallery-item group cursor-pointer";

      const isVideo =
        item.type === "video" ||
        item.src.includes(".mp4") ||
        item.src.includes(".webm");

      div.innerHTML = `
        <div class="relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
          ${
            isVideo
              ? `<video 
                  class="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300" 
                  muted 
                  loop 
                  playsinline>
                  <source src="${item.src}" type="video/mp4">
                  Video desteklenmiyor.
              </video>`
              : `<img 
                  src="${item.src}" 
                  alt="${item.alt}"
                  class="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  onerror="console.error('Image failed to load:', this.src)">`
          }
          <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div class="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <h3 class="font-semibold text-lg mb-1">${item.title}</h3>
            <p class="text-sm opacity-90">${item.desc}</p>
          </div>
          <div class="absolute top-4 right-4 bg-white/20 backdrop-blur-sm rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
          </div>
        </div>
      `;

      div.addEventListener("click", () => this.openModal(index));

      return div;
    },

    openModal: function (index) {
      this.currentModalIndex = index;
      if (this.modal) {
        this.modal.style.display = "flex";
        this.updateModalContent();
        document.body.style.overflow = "hidden";
      }
    },

    closeModal: function () {
      if (this.modal) {
        this.modal.style.display = "none";
        document.body.style.overflow = "";
        let videoElement = this.modal.querySelector("video");
        if (videoElement) {
          videoElement.pause();
          videoElement.currentTime = 0; // Reset video to start
        }
      }
    },

    updateModalContent: function () {
      const item = this.images[this.currentModalIndex];
      if (!item || !this.modalContent) return;

      const isVideo =
        item.type === "video" ||
        item.src.includes(".mp4") ||
        item.src.includes(".webm");

      this.modalContent.innerHTML = isVideo
        ? `<video controls class="max-w-full max-h-full" autoplay muted loop playsinline>
             <source src="${item.src}" type="video/mp4">
             Video desteklenmiyor.
           </video>`
        : `<img src="${item.src}" alt="${item.title}" class="max-w-full max-h-full object-contain">`;
    },

    previousModalItem: function () {
      this.currentModalIndex =
        this.currentModalIndex > 0
          ? this.currentModalIndex - 1
          : this.images.length - 1;
      this.updateModalContent();
    },

    nextModalItem: function () {
      this.currentModalIndex =
        this.currentModalIndex < this.images.length - 1
          ? this.currentModalIndex + 1
          : 0;
      this.updateModalContent();
    },

    previousPage: function () {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.renderPage();
        this.updatePagination();
      }
    },

    nextPage: function () {
      const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
      if (this.currentPage < totalPages - 1) {
        this.currentPage++;
        this.renderPage();
        this.updatePagination();
      }
    },

    updatePagination: function () {
      const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
      if (this.paginationInfo) {
        this.paginationInfo.textContent = `Page ${
          this.currentPage + 1
        } of ${totalPages}`;
      }
    },

    closeLightbox: function (overlay) {
      overlay.style.opacity = "0";

      // Remove keyboard listener
      if (overlay._handleKeyboard) {
        document.removeEventListener("keydown", overlay._handleKeyboard);
      }

      setTimeout(() => {
        if (overlay.parentNode) {
          overlay.remove();
        }
      }, 300);
    },

    initImageLazyLoading: function () {
      const images = document.querySelectorAll("img[data-src]");

      if (images.length === 0) return;

      const imageObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.src;
              img.classList.add("fade-in");
              imageObserver.unobserve(img);
            }
          });
        },
        {
          rootMargin: "100px",
        }
      );

      images.forEach((img) => imageObserver.observe(img));
    },

    initProjectFilter: function () {
      const filterButtons = document.querySelectorAll(".filter-btn");
      const projectItems = document.querySelectorAll(".project-item");

      if (filterButtons.length === 0 || projectItems.length === 0) return;

      filterButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
          const filter = btn.dataset.filter;

          // Update active button
          filterButtons.forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");

          // Filter projects
          projectItems.forEach((item) => {
            const category = item.dataset.category;

            if (filter === "all" || category === filter) {
              item.style.display = "block";
              item.classList.add("fade-in");
            } else {
              item.style.display = "none";
              item.classList.remove("fade-in");
            }
          });
        });
      });
    },

    loadImageWithPlaceholder: function (img) {
      const placeholder = document.createElement("div");
      placeholder.className = "bg-gray-200 animate-pulse";
      placeholder.style.width = img.offsetWidth + "px";
      placeholder.style.height = img.offsetHeight + "px";

      img.parentNode.insertBefore(placeholder, img);

      img.addEventListener("load", () => {
        placeholder.remove();
        img.classList.add("fade-in");
      });

      img.addEventListener("error", () => {
        placeholder.innerHTML =
          '<span class="text-gray-400">Image not found</span>';
      });
    },

    supportsWebP: function () {
      return new Promise((resolve) => {
        const webP = new Image();
        webP.onload = webP.onerror = () => {
          resolve(webP.height === 2);
        };
        webP.src =
          "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
      });
    },
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => gallery.init());
  } else {
    gallery.init();
  }
}

// Auto-initialize
if (document.getElementById("gallery-container")) {
  initGallery();
}
